/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest } from 'src/utils/RequestUtil';

export const stateSearchAPI = function (data) {
    const url = `${config.baseUrl}state/search`;
    return postRequest({
        url,
        data,
    });
};

export default {
    stateSearchAPI,
};
